export default "__VITE_ASSET__q5w4oBti__"